import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const ContactoPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Contacto</PageTitle>
      <View />
    </>
  );
};

export { ContactoPage };
